<template>
  <div class="page">
    <div class="name">支付聚合平台</div>
    <div class="content">
      <!-- 左侧图案 -->
      <leftImg></leftImg>
      <!-- 登录 -->
      <div class="right">
        <p class="name">登录</p>
        <div class="error">{{ errorMsg }}</div>
        <el-form :model="loginForm" class="form">
          <el-form-item prop="userName">
            <el-input
              v-model="loginForm.userName"
              prefix-icon="iconfont iconyonghu"
              placeholder="邮箱地址/手机号"
              maxlength="100"
            >
            </el-input>
          </el-form-item>
          <el-form-item prop="passWord">
            <el-input
              v-model="loginForm.passWord"
              prefix-icon="iconfont iconmima"
              placeholder="密码"
              show-password
              maxlength="30"
            ></el-input>
          </el-form-item>
          <el-form-item prop="imageData">
            <div class="test">
              <el-input v-model="loginForm.imageData" placeholder="验证码" maxlength="4"></el-input>
              <img class="vertify-meta-img" :src="imageCodeSrc" v-show="imageCodeSrc" />
              <span @click="getCodeAgain">换一张</span>
            </div>
          </el-form-item>
          <el-form-item>
            <div class="other">
              <span @click="changePage('forget')">忘记密码?</span>
              <span @click="changePage('register')">注册账户</span>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button class="login-btn" type="primary" @click="submitForm">登录</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import leftImg from '@login/components/leftImg';
import { checkLoginFormFormat } from '../static/loginUtil';
import { mapActions } from 'vuex';
import { debounce } from 'lodash';
export default {
  components: {
    leftImg,
  },
  data() {
    return {
      loginForm: {
        userName: '', // 用户名
        passWord: '', // 密码
        imageData: '', // 图片验证码
        id: '', // 图片验证码 id
        type: 'APP',
      },
      imageCodeSrc: '', // 图片路径
      errorMsg: '', //错误语提示
    };
  },
  created() {
    this.initData();
    this.getImageVerify();
  },
  methods: {
    ...mapActions('login', ['getImageVerifyCode', 'handleUserLogin', 'checkImageVerifyCode']),

    // 数据初始化
    initData() {
      // 绑定防抖函数
      this.getCodeAgain = debounce(this.getImageVerify, 2000, {
        leading: true,
        trailing: false,
      });
    },

    // 获取图片验证码数据
    async getImageVerify() {
      try {
        const { id = '', imageData = '' } = await this.getImageVerifyCode({
          type: this.loginForm.type,
        });
        this.loginForm.id = id;
        this.imageCodeSrc = `data:image/png;base64,${imageData}`;
      } catch (error) {
        console.error(error);
      }
    },

    // 点击“登录”
    async submitForm() {
      // 表单校验
      const checkRes = checkLoginFormFormat(this);
      if (!checkRes) return;
      // 执行图片验证码校验
      this.handleCheckImageVerifyCode()
        .then(() => {
          // 验证通过
          console.log('图片验证码 - 验证成功');
          this.handleLogin();
        })
        .catch(err => {
          // 验证失败
          console.error(err);
        });
    },

    // 图片验证码校验
    async handleCheckImageVerifyCode() {
      try {
        const { id, imageData, type } = this.loginForm;
        const params = { id, imageData, type };
        const checkRes = await this.checkImageVerifyCode(params);
        if (checkRes === 'success') {
          return Promise.resolve(checkRes);
        } else {
          this.errorMsg = '验证码错误';
          return Promise.reject(checkRes);
        }
      } catch (error) {
        console.error(error);
      }
    },

    // 发送登录请求
    async handleLogin() {
      const { passWord, userName } = this.loginForm;
      const params = { passWord, userName };
      try {
        const res = await this.handleUserLogin(params);
        if (res.userInfo) {
          this.errorMsg = '';
          this.$message.success('登录成功');
          this.$router.push('/index');
        }
      } catch (error) {
        this.errorMsg = '用户名或密码错误';
        console.error(error);
      }
    },

    // 忘记密码/注册
    changePage(item) {
      if (item === 'forget') {
        this.$router.push('/forget');
      } else {
        this.$router.push('/register');
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';
.page {
  height: 90vh;
  display: flex;
  flex-direction: column;
  padding: 5vh;
}
.name {
  font-size: 22px;
  color: #333;
  font-family: Noto Sans S Chinese;
  font-weight: 400;
}
.content {
  display: flex;
  width: 800px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 3px 6px rgba(67, 89, 183, 0.2);
  border-radius: 8px;
  margin: auto;
}
.right {
  width: 50%;
  height: 400px;
  .name {
    font-size: 22px;
    color: #333;
    padding: 18px 0;
    text-align: center;
    margin-bottom: 0;
  }
  .error {
    color: #ff5f5f;
    font-size: 14px;
    min-height: 24px;
    padding: 0 60px;
  }
  .form {
    max-width: 300px;
    margin: auto;
    .el-form-item {
      text-align: left;
      margin-bottom: 12px !important;
    }
  }
  /deep/.el-form-item__content {
    margin-left: 0 !important;
  }
  /deep/.iconfont {
    font-size: 14px;
    color: #999;
  }
  /deep/.iconfont,
  .iconyonghu {
    font-size: 18px;
  }
  .test {
    display: flex;
    justify-content: space-between;
    /deep/.el-input {
      width: 100px;
    }
    .vertify-meta-img {
      width: 100px;
      height: 40px;
    }
    span {
      font-size: 14px;
      color: #333;
      cursor: pointer;
    }
  }
  .other {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    color: #4359b7;
    span {
      cursor: pointer;
    }
  }
  .login-btn {
    width: 300px;
    font-size: 14px;
    font-family: Helvetica Neue;
    font-weight: 400;
  }
  /deep/.el-form-item__error {
    top: -18px;
    left: 15px;
  }
}
</style>
